import { Row, Col } from "antd";
import React from "react";
import * as R from "ramda";
import style from "./styles";

const EntityInfo = ({ entity, label, path, fieldName = null }) => {
    let nodes = R.path(path, entity);
    nodes = nodes ? [].concat(nodes) : null;
    return (
        <Row {...style.entityInfo}>
            <Col offset={2} span={6}>
                <span {...style.title}>{label}: </span>
            </Col>
            <Col span={16} data-testid={path[path.length - 1]}>
                {nodes && nodes.length
                    ? nodes.map((node, index) => (
                          <Row key={index}>
                              {fieldName ? node[fieldName] : node}
                          </Row>
                      ))
                    : "Unknown"}
            </Col>
        </Row>
    );
};

export default EntityInfo;
